import styled from '@emotion/styled';
import { alpha, IconButton, Stack } from '@mui/material';
import { shouldForwardProps } from '../../../utils';

const SmallSidenavItemStack = styled(Stack, shouldForwardProps)<{ isSelected: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 56px;
    padding-left: ${({ theme }) => theme.spacing(0.5)};
    padding-right: ${({ theme }) => theme.spacing(0.5)};
    color: ${({ theme, isSelected }) =>
        isSelected ? theme.colors.onPrimaryContainer : theme.colors.onSurfaceVariant};
    cursor: pointer;
`;

const SmallSideNavItemButton = styled(IconButton, shouldForwardProps)<{ isSelected: boolean }>`
    padding-left: ${({ theme }) => theme.spacing(2)};
    padding-right: ${({ theme }) => theme.spacing(2)};
    padding-top: ${({ theme }) => theme.spacing(0.5)};
    padding-bottom: ${({ theme }) => theme.spacing(0.5)};
    color: ${({ theme, isSelected }) =>
        isSelected ? theme.colors.onPrimaryDark : theme.colors.surfaceVariant};
    background-color: ${({ isSelected, theme }) =>
        isSelected ? theme.colors.darkSurfaceTint : 'transparent'};
    border-radius: 100px;

    &:hover {
        background-color: ${({ theme, isSelected }) => isSelected ? theme.colors.primaryContainer : alpha(theme.colors.darkSurfaceTint, 0.08)};
    }
`;

export { SmallSidenavItemStack, SmallSideNavItemButton };
